/**
 * 自助服务
 */
import { FC, useCallback, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useStoreState } from '@/store'
import css from './index.module.less'
import { Button, Image } from 'antd-mobile'
import { useNav } from '@/hooks/useNav'
import { DownOutline, UpOutline } from 'antd-mobile-icons'



export const SelfService: FC = () => {
  const { t } = useTranslation();
  const { centerConfig }: any = useStoreState();
  const { nav } = useNav();
  const [showMore, setShowMore] = useState(process.env.REACT_APP_IDN_ENV === 'hw' ? true : false)

  const toAddOrderPage = (id) => nav(`/add-order/${id}`);

  const onToggle = useCallback(() => setShowMore(prevState => !prevState), [])

  return (
    <div className={css.SelfService}>
      <div className={css.CommonTitle}>
        <span>{t('self-center.title-2')}</span>
        {(centerConfig.workOrders?.length > 8 && process.env.REACT_APP_IDN_ENV !== 'hw') && (
          <Button size={'mini'} color={'primary'} fill='none' onClick={onToggle}>
            {showMore ? `${t('self-center.put')}` : `${t('self-center.more')}`}
            {showMore ? <UpOutline /> : <DownOutline />}
          </Button>
        )}
      </div>

      <div className={`${css.BdContent} ${showMore ? css.showMore : ''}`}>
        {centerConfig.workOrders?.map(cate => (
          <div className={css.BdChunkWrap} key={cate.id}>
            <div className={css.BdChunk} onClick={() => toAddOrderPage(cate.id)}>
              <Image className={css.ChunkIcon} src={cate.icon} />
              <div className={`${css.ChunkName} ellipsis-two-lines`}>{cate.serverName}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
